import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import * as R from 'ramda';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import OBNDBNBizComponent from '../components/obn-dbn-biz.component';
import { useAppDispatch, useAppSelector } from '../../../../hooks/hooks';
import { selectCurrent } from '../../../../redux/settings/selectors';
import { selectGlobalOBNDBNBizsQueryItems } from '../../../../redux/obn-dbn-bizs/selector';
import storePersist from '../../../../redux/storePersist';
import { deepCopy } from '../../../../common/services/common.service';
import { globalOBNDBNBizs } from '../../../../redux/obn-dbn-bizs/action';
import { settings } from '../../../../redux/settings/actions';
import PageLoader from '../../../../components/PageLoader';
import UploadFiles from '../../../../models/UploadFile';
import { selectOpenNetworkRegistrationsListItems } from '../../../../redux/open-network-registrations/selector';
import { openNetworkRegistrations } from '../../../../redux/open-network-registrations/action';
import { selectGlobalBizNetTypesListItems } from '../../../../redux/global-biz-net-types/selector';
import { globalBizNetTypes } from '../../../../redux/global-biz-net-types/action';

let currentChange: any = {}
const OBNBIZ = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
   const parmas: any = useParams()
  const { getUploadFiles } = useAppSelector(selectCurrent)
  const obnDBNBizQuery = useSelector(selectGlobalOBNDBNBizsQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  // const accountsItems = useSelector(selectAccountsListItems)
  // const shippingProvidersListItems = useSelector(selectShippingProvidersListItems)
  // const obnDBNBizItems = useSelector(selectGlobalOBNDBNBizsListItems)
  // const shippingTypesListItems = useSelector(selectShippingTypesListItems)
  const libraryListItems = storePersist?.get("library")?.current;
  const openNetworkRegistrationsItems = useSelector(selectOpenNetworkRegistrationsListItems)
  const [obnDBNBiz, setOBNDBNBiz] = useState<any>([])
  const [selectedOBNDBNBiz, setSelectedOBNDBNBiz] = useState<any>({
    Circle: {
      radius: {}
    },
    Time: {
      schedule: {},
      range: {}
    }
  })

  const [keys, setKeys] = useState<any>([])
  // const dbnpregistriesItems = useSelector(selectDbnpRegistriesListItems)
  const [openConfirmationFile, setOpenConfirmationFile] = React.useState(false);
  const [openConfirmationLogoFile, setOpenConfirmationLogoFile] = React.useState(false);
  const [openConfirmationFavFile, setOpenConfirmationFavFile] = React.useState(false);
  const [logoFiles, setLogoFiles] = useState<any>([]);
  const [favFiles, setFavFiles] = useState<any>([]);
  const [openImageFile, setOpenImageFile] = useState<any>([]);
  const [brandMappings, setBrandMappings] = useState<any>([]);
  const [openFile, setOpenFile] = useState<any>([]);
    const bizNetItems = useSelector(selectGlobalBizNetTypesListItems)
  const addNewRow = ({ selectedKeysArg }: any) => {
    const localSelectedKeys = deepCopy(selectedKeysArg)
    const newsSelectedKeysRecord = {
      Id: 0,
      signing_pvt_key: '',
      signing_pub_key: '',
      encryption_pvt_key: '',
      encryption_pub_key: ''
    }
    if (localSelectedKeys.length === 0 ||
      localSelectedKeys[localSelectedKeys?.length - 1]?.signing_pvt_key !== ''
    ) {
      localSelectedKeys?.push(newsSelectedKeysRecord)
    }

    return localSelectedKeys
  }

  const setKeysInfo = async () => {
    let localSelectedKeys = deepCopy(keys)
    localSelectedKeys.splice(
      currentChange.idx,
      1,
      { ...localSelectedKeys[currentChange.idx] }
    );
    localSelectedKeys = addNewRow({ selectedKeysArg: localSelectedKeys });
    currentChange.field = 'signing_pvt_keyDONE'
    setKeys(localSelectedKeys)
  }

  const fetchOBNDBNBizById = async () => {
    await dispatch(globalOBNDBNBizs.query({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/obn-bizs/fetch-detail`,
      entity: 'globalOBNDBNBizs',
      jsonData: {
        Context: {},
        Records: [
          {
            Id: parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

 

  useEffect(() => {
    // fetchShippingProviders();
    // fetchOBNDBNBizListData();
    // dispatch(shippingTypes.list({
    //   url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/shipping-types/list`,
    //   entity: 'shippingTypes',
    //   jsonData: {
    //   }
    // })).then(() => {
    //   dispatch(dbnpRegistries.list({
    //     url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/platform-management/dbnp-registries/list`,
    //     entity: 'dbnpRegistries',
    //     jsonData: {
    //       "Filters": [
    //         {
    //           "FieldName": "IsProxyNetwork",
    //           "FilterOperatorId": 1,
    //           "FieldValue": false,
    //           "FieldType": "boolean"
    //         },
    //       ],
    //     }
    //   }))
    // }).then(() => {
       dispatch(openNetworkRegistrations.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/open-network-registrations/list`,entity:'openNetworkRegistrations',jsonData:{
            }}))
    .then(() => {

        dispatch(globalBizNetTypes.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-biz-net-types/list`,entity:'globalBizNetTypes',jsonData:{      
            
            }}))}).then(() => {
      if (parmas?.id > 0) {
        fetchOBNDBNBizById()
        setIsLoading(false)
      } else {
        const currentSelectedKeys = addNewRow({ selectedKeysArg: keys });
        setKeys(currentSelectedKeys)
        const localSelectedBrands = addNewBrandMappingRow({ selectedBrandsArg: brandMappings });
        setBrandMappings(localSelectedBrands)
        const localSelectedLogo = addNewLogoFilesRow({ selectedLogoFilesArg: logoFiles, brandMapping: brandMappings, idx1: 0 });
        setLogoFiles(localSelectedLogo)
        setIsLoading(false)
      }
     })
  }, []
  )

  useEffect(() => {
    const transporterMapping = obnDBNBizQuery?.result?.items?.PreferredDBNLogisticsTransporterMapping;
    if (isQuery) {
      setOBNDBNBiz({
        ...obnDBNBizQuery?.result?.items,
        Name:obnDBNBizQuery?.result?.items?.Name,
        Email:obnDBNBizQuery?.result?.items?.Email,
        PhoneNumber: obnDBNBizQuery?.result?.items?.PhoneNumber,
        AccountTypeId: obnDBNBizQuery?.result?.items?.AccountInfo?.TypeId,
        AccountId: obnDBNBizQuery?.result?.items?.AccountInfo?.AccountId,
        AccountPId: obnDBNBizQuery?.result?.items?.AccountInfo?.AccountPId,
        BizNetTypeIds: obnDBNBizQuery?.result?.items?.BizNetTypeIds,
        PreferredDBNLogisticsTransporterMapping: Array.isArray(transporterMapping)
          ? transporterMapping.map((item: any) => item?.TransporterAccountId).filter(Boolean)
          : [],
               City: obnDBNBizQuery?.result?.items?.City,
                 Address: obnDBNBizQuery?.result?.items?.Address,
      CountryId: obnDBNBizQuery?.result?.items?.CountryId,
      StateProvinceId:obnDBNBizQuery?.result?.items?.StateProvinceId
      })
      const newString = obnDBNBizQuery?.result?.items?.Time?.days
      const daysArray: any = newString?.split(',').map(Number);
      setSelectedOBNDBNBiz(
        {
          gps: obnDBNBizQuery?.result?.items?.Circle?.gps,
          unit: obnDBNBizQuery?.result?.items?.Circle?.radius?.unit,
          value: obnDBNBizQuery?.result?.items?.Circle?.radius?.value,
          days: daysArray,
          holidays: obnDBNBizQuery?.result?.items?.Time?.schedule?.holidays,
          frequency: obnDBNBizQuery?.result?.items?.Time?.schedule?.frequency,
          times: obnDBNBizQuery?.result?.items?.Time?.schedule?.times,
          start: obnDBNBizQuery?.result?.items?.Time?.range?.start,
          end: obnDBNBizQuery?.result?.items?.Time?.range?.end,
        }
      )
      const currentSelectedKeys = addNewRow({ selectedKeysArg: obnDBNBizQuery?.result?.items?.Keys || [] });
      setKeys(currentSelectedKeys)
      const brandData: any = obnDBNBizQuery?.result?.items?.AccountInfo?.BrandMappings?.map((item: any) => {
        const itemData = {
          Id: item?.Id,
          Name: item?.Name,
          Description: item?.Description,
          PrimaryColor: item?.Configurations?.Branding?.Primary?.Color,
          PrimaryBackgroundColor: item?.Configurations?.Branding?.Primary?.BackgroundColor,
          PrimaryBackgroundImage: item?.Configurations?.Branding?.Primary?.BackgroundImage,
          SecondaryColor: item?.Configurations?.Branding?.Secondary?.Color,
          SecondaryBackgroundColor: item?.Configurations?.Branding?.Secondary?.BackgroundColor,
          SecondaryBackgroundImage: item?.Configurations?.Branding?.Secondary?.BackgroundImage,
          TertiaryColor: item?.Configurations?.Branding?.Tertiary?.Color,
          TertiaryBackgroundColor: item?.Configurations?.Branding?.Tertiary?.BackgroundColor,
          TertiaryBackgroundImage: item?.Configurations?.Branding?.Tertiary?.BackgroundImage,
          GhostColor: item?.Configurations?.Branding?.Ghost?.Color,
          GhostBackgroundColor: item?.Configurations?.Branding?.Ghost?.BackgroundColor,
          GhostBackgroundImage: item?.Configurations?.Branding?.Ghost?.BackgroundImage,
          Logos: item?.Configurations?.Logos?.map((logoItem: any) => {
            return {
              Url: logoItem.Url,
              Size: logoItem.Size,
              Background: logoItem.Background,
            };
          }),
          Favicons: item?.Configurations?.Favicons?.map((favItem: any) => {
            return {
              Url: favItem.Url,
              Size: favItem.Size,
              Background: favItem.Background,
            };
          }),
        }
        return itemData
      })
      const localSelectedbrands = addNewBrandMappingRow({ selectedBrandsArg: brandData || [] });
      setBrandMappings(localSelectedbrands)
      const updatedLogo = brandData?.map((brandMapping: any, index: any) => {
        const localSelectedlogo = addNewLogoFilesRow({
          selectedLogoFilesArg: brandMapping.Logos,
          brandMapping: localSelectedbrands,
          idx: brandMapping.Logos.length,
          idx1: index
        });
        return localSelectedlogo;
      });

      setLogoFiles(updatedLogo)
      const updatedFav = brandData?.map((brandMapping: any, index: any) => {
        const localSelectedlogo = addNewFavFilesRow({
          selectedFavFilesArg: brandMapping.Favicons,
          brandMapping: localSelectedbrands,
          idx: brandMapping.Favicons.length,
          idx1: index
        });
        return localSelectedlogo;
      });
      setFavFiles(updatedFav)
    }
  }, [isQuery]
  )

  const handleFormItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(keys);// deep copy of activity items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setKeys(items);
  }

  const handleFormChange: any = ({ field, value }: any) => {
    currentChange = { value, field }
    setOBNDBNBiz({ ...obnDBNBiz, [field]: value })
    setSelectedOBNDBNBiz({ ...selectedOBNDBNBiz, [field]: value })
  }

  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectedOBNDBNBiz({ ...selectedOBNDBNBiz, [fields[0]]: value });
    // setSelectedAddress({ ...selectedAddress, [fields[0]]: value });
  }

  const handleFormItemBrandChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(brandMappings);
    let item = items[idx];
    item = { ...item, [field]: value }
    items[idx] = item;
    currentChange = { value, field, idx }
    setBrandMappings(items);
  }

  const handleFormLogoItemChange = ({ value, field, idx, cardValue, idx1 }: any) => {
    const items = deepCopy(cardValue.Logos);
    items[idx] = { ...items[idx], [field]: value };
    setLogoFiles(items);
    const updatedCardValue = [...brandMappings];
    updatedCardValue[idx1] = { ...cardValue, Logos: items };
    setBrandMappings(updatedCardValue);
  }

  const handleFormFavItemChange = ({ value, field, idx, cardValue, idx1 }: any) => {
    const items = deepCopy(cardValue.Favicons);
    items[idx] = { ...items[idx], [field]: value };
    setFavFiles(items);
    const updatedCardValue = [...brandMappings];
    updatedCardValue[idx1] = { ...cardValue, Favicons: items };
    setBrandMappings(updatedCardValue);
  }

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    keys.splice(
      keys.length - 1,
      1
    )
    brandMappings.splice(
      brandMappings.length - 1,
      1
    )
    const brandData: any = brandMappings?.map((item: any) => {
      if (item?.Logos?.length) {
        item.Logos.splice(item.Logos.length - 1, 1);
      }
      if (item?.Favicons?.length) {
        item.Favicons.splice(item.Favicons.length - 1, 1);
      }
      const itemData = {
        Id: item?.Id,
        Name: item?.Name,
        Description: item?.Description,
        Configurations: {
          Logos: item?.Logos?.map((logoItem: any) => {
            return {
              Url: logoItem.Url,
              Size: logoItem.Size,
              Background: logoItem.Background,
            };
          }),
          Favicons: item?.Favicons?.map((favItem: any) => {
            return {
              Url: favItem.Url,
              Size: favItem.Size,
              Background: favItem.Background,
            };
          }),
          Branding: {
            Primary: {
              Color: item?.PrimaryColor,
              BackgroundColor: item?.PrimaryBackgroundColor,
              BackgroundImage: item?.PrimaryBackgroundImage
            },
            Secondary: {
              Color: item?.SecondaryColor,
              BackgroundColor: item?.SecondaryBackgroundColor,
              BackgroundImage: item?.SecondaryBackgroundImage
            },
            Tertiary: {
              Color: item?.TertiaryColor,
              BackgroundColor: item?.TertiaryBackgroundColor,
              BackgroundImage: item?.TertiaryBackgroundImage
            },
            Ghost: {
              Color: item?.GhostColor,
              BackgroundColor: item?.GhostBackgroundColor,
              BackgroundImage: item?.GhostBackgroundImage
            },
          },
        }
      }
      return itemData
    })
    const newString: any = selectedOBNDBNBiz?.days?.map((x: any) => x).join(',')
    
    const obnDBNBizDataCreate = {
      Name: obnDBNBiz?.Name || '',
      Email: obnDBNBiz?.Email || '',
      PhoneNumber: obnDBNBiz?.PhoneNumber ||'',
      OBNRegistryId: obnDBNBiz?.OBNRegistryId || 0,
      DBNPId: obnDBNBiz?.DBNPId || 0,
      IsAcceptOrderByDefaultEnabled: obnDBNBiz?.IsAcceptOrderByDefaultEnabled || false,
      IsDirectShipmentEnabled: obnDBNBiz?.IsDirectShipmentEnabled || false,
      Keys: keys || [],
      UkId: obnDBNBiz?.UkId || "",
      Delivery_preference: obnDBNBiz?.Delivery_preference || "",
      Shipping_category: obnDBNBiz?.Shipping_category || "",
      Circle: {
        gps: selectedOBNDBNBiz?.gps || "",
        radius: {
          unit: selectedOBNDBNBiz?.unit || "",
          value: selectedOBNDBNBiz?.value || "",
        },
      },
      Time: {
        days: newString || "",
        schedule: {
          holidays: selectedOBNDBNBiz?.holidays || [],
          frequency: selectedOBNDBNBiz?.frequency || "",
          times: selectedOBNDBNBiz?.times || [],
        },
        range: {
          start: selectedOBNDBNBiz?.start || "",
          end: selectedOBNDBNBiz?.end || "",
        },
      },
      CurrentlyServicing: obnDBNBiz?.CurrentlyServicing || false,
      UseSettingsFromConfigFile: obnDBNBiz?.UseSettingsFromConfigFile || false,
      Stdcode: obnDBNBiz?.Stdcode || "string",
      ShippingTypeId: obnDBNBiz?.ShippingTypeId || 0,
      ShippingOptionIds: obnDBNBiz?.ShippingOptionIds || [],
      IsTrackingEnabled: obnDBNBiz?.IsTrackingEnabled || false,
      Tracking: {
        code: obnDBNBiz?.Tracking?.code || "",
        list: [
          {
            code: obnDBNBiz?.code || '',
            value: obnDBNBiz?.value || '',
          },
        ],
      },
      BizNetTypeIds: obnDBNBiz?.BizNetTypeIds || [],
      BizNetTypeGroupId: obnDBNBiz?.BizNetTypeGroupId || 0,
      Address: obnDBNBiz?.Address,
      City: obnDBNBiz?.City,
      CountryId: obnDBNBiz?.CountryId,
      StateProvinceId:obnDBNBiz?.StateProvinceId
    };

    const obnDBNBizDataUpdate = {
      Id: obnDBNBiz?.OBNBizId || 0,
           Name: obnDBNBiz?.Name || '',
      Email: obnDBNBiz?.Email || '',
      PhoneNumber: obnDBNBiz?.PhoneNumber ||'',
      OBNRegistryId: obnDBNBiz?.OBNRegistryId || 0,
      DBNPId: obnDBNBiz?.DBNPId || 0,
      ParentDBAId: obnDBNBiz?.ParentDBAId || 0,
      IsAcceptOrderByDefaultEnabled:
        obnDBNBiz?.IsAcceptOrderByDefaultEnabled || false,
      IsDirectShipmentEnabled: obnDBNBiz?.IsDirectShipmentEnabled || false,
      Keys: keys || [],
      UkId: obnDBNBiz?.UkId || "",
      Delivery_preference: obnDBNBiz?.Delivery_preference || "",
      Shipping_category: obnDBNBiz?.Shipping_category || "",
      Circle: {
        gps: selectedOBNDBNBiz?.gps || "",
        radius: {
          unit: selectedOBNDBNBiz?.unit || "",
          value: selectedOBNDBNBiz?.value || "",
        },
      },
      Time: {
        days: newString || "string",
        schedule: {
          holidays: selectedOBNDBNBiz?.holidays || ["string"],
          frequency: selectedOBNDBNBiz?.frequency || "string",
          times: selectedOBNDBNBiz?.times || ["string"],
        },
        range: {
          start: selectedOBNDBNBiz?.start || "string",
          end: selectedOBNDBNBiz?.end || "string",
        },
      },
      CurrentlyServicing: obnDBNBiz?.CurrentlyServicing || false,
      UseSettingsFromConfigFile: obnDBNBiz?.UseSettingsFromConfigFile || false,
      Stdcode: obnDBNBiz?.Stdcode || "string",
      ShippingOptionIds: obnDBNBiz?.ShippingOptionIds || [],
      IsTrackingEnabled: obnDBNBiz?.IsTrackingEnabled || false,
       BizNetTypeIds: obnDBNBiz?.BizNetTypeIds || [],
      BizNetTypeGroupId: obnDBNBiz?.BizNetTypeGroupId || 0,
      Tracking: {
        code: obnDBNBiz?.Tracking?.code || "",
        list: [
          {
            code: obnDBNBiz?.code || '',
            value: obnDBNBiz?.value || '',
          },
        ],
      },
      BrandMappings: obnDBNBiz?.BrandMappings,
        Address: obnDBNBiz?.Address,
           City: obnDBNBiz?.City,
      CountryId: obnDBNBiz?.CountryId,
      StateProvinceId:obnDBNBiz?.StateProvinceId
    };

    if (parmas?.id >0) {
      await dispatch(globalOBNDBNBizs.resetAction({ actionType: 'update' }))
      await dispatch(globalOBNDBNBizs.update({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/obn-bizs`,
        entity: 'globalOBNDBNBizs',
        jsonData: {
          Context: {},
          Records: [obnDBNBizDataUpdate]
        }
      })).then(() => {
        back()
      })
    } else {
      await dispatch(globalOBNDBNBizs.resetAction({ actionType: 'create' }))
      await dispatch(globalOBNDBNBizs.create({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/obn-bizs`,
        entity: 'globalOBNDBNBizs',
        jsonData: {
          Context: {},
          Records: [obnDBNBizDataCreate]
        }
      })).then(() => {
        back()
      })
    }
  }

  const back = () => {
    navigate(-1)
  }

  const deleteKeys = async (Item: any, index: any) => {
    setKeys((prevKeys) => {
      const updated = deepCopy(prevKeys);
      updated.splice(index, 1);
      return updated;
    });
  }

  useEffect(() => {
    if (currentChange.field === 'signing_pvt_key') {
      setKeysInfo()
    }
  }, [keys]
  )

  const handleClose = () => {
    if (openConfirmationLogoFile) {
      setOpenConfirmationLogoFile(false)
    } else if (openConfirmationFavFile) {
      setOpenConfirmationFavFile(false)
    }
    dispatch(settings.set({ getUploadFiles: 'close' }))
  }

  const addNewBrandMappingRow = ({ selectedBrandsArg }: any) => {
    const localSelectedBrands = deepCopy(selectedBrandsArg)
    const newsBrand = {
      Id: 0,
      Name: '',
      Description: '',
      Logos: [
        {
          Url: '',
          Size: '',
          Background: '',
        }
      ],
      Favicons: [
        {
          Url: '',
          Size: '',
          Background: '',
        }
      ],
      Branding: {
        Primary: {},
        Secondary: {},
        Tertiary: {},
        Ghost: {}
      }
    }
    if (localSelectedBrands.length === 0 ||
      localSelectedBrands[localSelectedBrands?.length - 1]?.Name !== ''
    ) {
      localSelectedBrands?.push(newsBrand);
    }
    return localSelectedBrands
  }

  const addNewLogoFilesRow = ({ selectedLogoFilesArg, brandMapping, idx, idx1 }: any) => {
    const localSelectedlogo = deepCopy(selectedLogoFilesArg)
    const newSelectedLogo = {
      Url: '',
      Size: '',
      Background: '',
    }
    if (localSelectedlogo.length === 0 ||
      brandMapping[idx1]?.Logos[brandMapping[idx1].Logos?.length - 1]?.Url !== ''
    ) {
      brandMapping[idx1]?.Logos?.push(newSelectedLogo)
    }
    return localSelectedlogo
  }

  const addNewFavFilesRow = ({ selectedFavFilesArg, brandMapping, idx, idx1 }: any) => {
    const localSelectedfav = deepCopy(selectedFavFilesArg)
    const newSelectedFav = {
      Url: '',
      Size: '',
      Background: '',
    }
    if (localSelectedfav.length === 0 ||
      brandMapping[idx1]?.Favicons[brandMapping[idx1].Favicons?.length - 1]?.Url !== ''
    ) {
      brandMapping[idx1]?.Favicons?.push(newSelectedFav)
    }
    return localSelectedfav
  }

  const setCombinationLogoInfo = async () => {
    let localSelectedLogo = deepCopy(logoFiles)
    localSelectedLogo.splice(
      currentChange.idx,
      1,
      { ...localSelectedLogo[currentChange.idx] }
    );
    localSelectedLogo = addNewLogoFilesRow({ selectedLogoFilesArg: localSelectedLogo, brandMapping: brandMappings, idx1: currentChange.idx });
    currentChange.field = 'UrlDONE'
    setLogoFiles(localSelectedLogo)
  }

  const setCombinationFavInfo = async () => {
    let localSelectedFav = deepCopy(favFiles)
    localSelectedFav.splice(
      currentChange.idx,
      1,
      { ...localSelectedFav[currentChange.idx] }
    );
    localSelectedFav = addNewFavFilesRow({ selectedFavFilesArg: localSelectedFav, brandMapping: brandMappings, idx1: currentChange.idx });
    currentChange.field = 'UrlDONE'
    setFavFiles(localSelectedFav)
  }

  const setCombinationBrandInfo = async () => {
    let localSelectedbrands = deepCopy(brandMappings)
    localSelectedbrands.splice(
      currentChange.idx,
      1,
      { ...localSelectedbrands[currentChange.idx] }
    );
    localSelectedbrands = addNewBrandMappingRow({ selectedBrandsArg: localSelectedbrands });
    currentChange.field = 'NameDONE'
    setBrandMappings(localSelectedbrands)
  }

  useEffect(() => {
    if (currentChange.field === 'Url') {
      setCombinationLogoInfo()
    }
  }, [currentChange.field, currentChange.idx]
  )

  useEffect(() => {
    if (currentChange.field === 'Url') {
      setCombinationFavInfo()
    }
  }, [currentChange.field, currentChange.idx]
  )

  useEffect(() => {
    if (currentChange.field === 'Name') {
      setCombinationBrandInfo()
    }
  }, [brandMappings]
  )

  const handleLogoSubmit = (data: any) => {
    const newLogoFiles = [...logoFiles];
    const logosArray = brandMappings[currentChange.idx1]?.Logos;
    logosArray[currentChange.idx].Url = data;
    const localSelectedLogo = addNewLogoFilesRow({
      selectedLogoFilesArg: newLogoFiles,
      brandMapping: brandMappings,
      idx: currentChange.idx,
      idx1: currentChange.idx1,
      data: data
    });
    setLogoFiles(localSelectedLogo)
  }

  const changeImage = (idx: number, templateField: any, fileType: any, brandMaping: any) => {
    // setOrganizationUnitImageIndex(idx)
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenConfirmationFile(true)
    setOpenFile({
      currentFileSrc: brandMaping[idx][templateField],
      folder: 'Organizationunit',
      type: fileType
    })
  }

  const changeLogoImage = (idx: number, templateField: any, fileType: any, brandMaping: any, idx1: any) => {
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenConfirmationLogoFile(true)
    setOpenImageFile({
      currentFileSrc: brandMaping[idx1]?.Logos[idx][templateField],
      folder: 'Organizationunit',
      type: fileType
    })
    currentChange = { idx, templateField, idx1 }
  }

  const changeFavImage = (idx: number, templateField: any, fileType: any, brandMaping: any, idx1: any) => {
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenConfirmationFavFile(true)
    setOpenImageFile({
      currentFileSrc: brandMaping[idx1]?.Favicons[idx][templateField],
      folder: 'Organizationunit',
      type: fileType
    })
    currentChange = { idx, templateField, idx1 }
  }

  const handleFavSubmit = (data: any) => {
    const newfavFiles = [...favFiles];
    const favsArray = brandMappings[currentChange.idx1]?.Favicons;
    favsArray[currentChange.idx].Url = data;
    const localSelectedFav = addNewFavFilesRow({
      selectedFavFilesArg: newfavFiles,
      brandMapping: brandMappings,
      idx: currentChange.idx,
      idx1: currentChange.idx1,
      data: data
    });
    setFavFiles(localSelectedFav)
  }

  return (
    <>
      {getUploadFiles == 'open' && openConfirmationLogoFile && <UploadFiles currentFilesSrc={openFile?.currentFileSrc}
        folder={openImageFile?.folder}
        handleClose={handleClose}
        handleFilesSubmit={handleLogoSubmit}
        type={openImageFile?.type}
        ownerId={parmas?.id}
      />}
      {getUploadFiles == 'open' && openConfirmationFavFile && <UploadFiles currentFilesSrc={openFile?.currentFileSrc}
        folder={openImageFile?.folder}
        handleClose={handleClose}
        handleFilesSubmit={handleFavSubmit}
        type={openImageFile?.type}
        ownerId={parmas?.id}
      />}
      {obnDBNBizQuery?.isLoading ? <PageLoader /> :
        <OBNDBNBizComponent
          deleteKeys={deleteKeys}
          accountType={libraryListItems?.Type}
          deliveryPreference={libraryListItems?.DeliveryPreference}
          onFormItemChange={handleFormItemChange}
          keys={keys}
          onFormChange={handleFormChange}
          obnDBNBiz={obnDBNBiz}
          // fetchAcount={fetchAcount}
          // accounts={accountsItems?.result?.items}
          // shippingProviders={shippingProvidersListItems?.result?.items}
          id={parmas?.id}
          selectedOBNDBNBiz={selectedOBNDBNBiz}
          // shippingTypes={shippingTypesListItems?.result?.items}
          back={back}
          handleFormSubmit={handleFormSubmit}
          onFormFavItemChange={handleFormFavItemChange}
          changeFavImage={changeFavImage}
          logoFiles={logoFiles}
          onFormLogoItemChange={handleFormLogoItemChange}
          faviconSize={libraryListItems?.FaviconSize}
          changeLogoImage={changeLogoImage}
          logoBackground={libraryListItems?.LogoBackground}
          onFormItemBrandChange={handleFormItemBrandChange}
          brandMappings={brandMappings}
          fileTypes={libraryListItems?.FileType}
          changeImage={changeImage}
          handleInnerbasicFormChange={handleFormChange}
          // selectedAddress={selectedAddress}
          // timeZones={timeZonesItems?.result?.items}
          currencyRoundingType={libraryListItems?.RoundingType}
          currencyCodeType={libraryListItems?.CurrencyCodeType}
          // selectedOrganizationUnit={selectedOBNDBNBiz}
          onInnerFormChange={handleInnerFormChange}
          // dbnpregistries={dbnpregistriesItems?.result?.items}
          shippingOptionList={libraryListItems?.ShippingOption}
          // oBNDBNBizsList={obnDBNBizItems?.result?.items}
          openNetworkRegistries={openNetworkRegistrationsItems?.result?.items}
          bizNetTypes={bizNetItems?.result?.items}
        />
      }
    </>
  );
};

export default OBNBIZ;